

// // src/pages/Staff/StaffList.jsx
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";
// import StaffForm from "./StaffForm";
// import { formatUserId } from "../../utils/formatId";
// import { EllipsisVerticalIcon, XMarkIcon } from "@heroicons/react/24/outline";

// export default function StaffList() {
//   const [users, setUsers] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [query, setQuery] = useState("");
//   const [roleFilter, setRoleFilter] = useState("All");
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [isPanelOpen, setIsPanelOpen] = useState(false);
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [deleting, setDeleting] = useState(false); // Prevent double-click

//   const getRoleCaption = (roleId) => {
//     const role = roles.find((r) => r.id === roleId);
//     return role ? (role.caption || role.name) : "Unknown";
//   };

//   async function load() {
//     try {
//       const [userRes, roleRes] = await Promise.all([
//         api.get("/users"),
//         api.get("/roles"),
//       ]);
//       setUsers(userRes.data.users || []);
//       setRoles(roleRes.data.roles || []);
//     } catch (err) {
//       console.error("Load failed:", err);
//       alert("Failed to load staff data");
//     }
//   }

//   useEffect(() => {
//     load();
//   }, []);

//   const filtered = users.filter((u) => {
//     const searchText = [u.name, u.email, getRoleCaption(u.role_id)].join(" ").toLowerCase();
//     const matchesQuery = !query || searchText.includes(query.toLowerCase());
//     const matchesRole = roleFilter === "All" || u.role_id === Number(roleFilter);
//     return matchesQuery && matchesRole;
//   });

//   // FIXED DELETE FUNCTION
//   async function remove(id) {
//     if (deleting) return; // Prevent double delete
//     if (!window.confirm("Are you sure you want to delete this user? This action cannot be undone.")) return;

//     setDeleting(true);
//     try {
//       await api.delete(`/users/${id}`); // Make sure this matches your backend route
//       // Success: remove from local state immediately for instant feedback
//       setUsers(prev => prev.filter(u => u.id !== id));
//       setOpenMenuId(null);
//       // Optional: show success message
//       alert("User deleted successfully");
//     } catch (err) {
//       console.error("Delete error:", err);
//       const message = err?.response?.data?.message || "Failed to delete user. It may be in use or protected.";
//       alert(message);
//     } finally {
//       setDeleting(false);
//     }
//   }

//   const openAddPanel = () => {
//     setSelectedUser(null);
//     setIsPanelOpen(true);
//   };

//   const openEditPanel = (user) => {
//     setSelectedUser(user);
//     setIsPanelOpen(true);
//   };

//   const closePanel = () => {
//     setIsPanelOpen(false);
//     setSelectedUser(null);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 py-8 px-6">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-8">
//           <h1 className="text-3xl font-bold text-gray-900">All User</h1>
//           <button
//             onClick={openAddPanel}
//             className="px-8 py-3 bg-[#0f172a] hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg transition"
//           >
//             + Add Staff
//           </button>
//         </div>

//         {/* Search & Filter */}
//         <div className="flex flex-col md:flex-row gap-4 mb-8">
//           <input
//             type="text"
//             placeholder="Search by name, email, role..."
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             className="flex-1 px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500"
//           />
//           <select
//             value={roleFilter}
//             onChange={(e) => setRoleFilter(e.target.value)}
//             className="px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500"
//           >
//             <option value="All">All Roles</option>
//             {roles.map((r) => (
//               <option key={r.id} value={r.id}>
//                 {r.caption || r.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Table */}
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gray-100 border-b-2 border-gray-300">
//                 <tr>
//                   <th className="px-6 py-4 text-left text-sm font-bold text-gray-700">ID</th>
//                   <th className="px-6 py-4 text-left text-sm font-bold text-gray-700">Name</th>
//                   <th className="px-6 py-4 text-left text-sm font-bold text-gray-700">User Role</th>
//                   <th className="px-6 py-4 text-left text-sm font-bold text-gray-700">Registration Date</th>
//                   <th className="px-6 py-4 text-center text-sm font-bold text-gray-700">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {filtered.map((u) => (
//                   <tr key={u.id} className="hover:bg-orange-50/30 transition-colors">
//                     <td className="px-6 py-4 text-orange-600 font-bold text-sm">
//                       {formatUserId(u.id)}
//                     </td>
//                     <td className="px-6 py-4 text-gray-900 font-medium text-sm">{u.name}</td>
//                     <td className="px-6 py-4 text-gray-700 text-sm">{getRoleCaption(u.role_id)}</td>
//                     <td className="px-6 py-4 text-gray-600 text-sm">
//                       {new Date(u.created_at).toLocaleDateString("en-GB")} |{" "}
//                       {new Date(u.created_at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
//                     </td>
//                     <td className="px-6 py-4 text-center relative">
//                       <button
//                         onClick={() => setOpenMenuId(openMenuId === u.id ? null : u.id)}
//                         disabled={deleting}
//                         className="p-2 hover:bg-gray-100 rounded-lg transition disabled:opacity-50"
//                       >
//                         <EllipsisVerticalIcon className="w-5 h-5 text-gray-500" />
//                       </button>

//                       {openMenuId === u.id && (
//                         <div className="absolute right-6 top-12 bg-white border border-gray-200 rounded-xl shadow-2xl py-2 z-50 min-w-36">
//                           <button
//                             onClick={() => {
//                               openEditPanel(u);
//                               setOpenMenuId(null);
//                             }}
//                             className="w-full text-left px-5 py-2.5 text-gray-700 hover:bg-orange-50 transition text-sm"
//                           >
//                             Edit
//                           </button>
//                           {/* <button
//                             onClick={() => remove(u.id)}
//                             disabled={deleting}
//                             className="w-full text-left px-5 py-2.5 text-red-600 hover:bg-red-50 transition text-sm disabled:opacity-50"
//                           >
//                             {deleting ? "Deleting..." : "Delete"}
//                           </button> */}
//                           <button
//   onClick={() => remove(u.id)}
//   className="w-full text-left px-5 py-2.5 text-orange-600 hover:bg-orange-50 transition text-sm"
// >
//   Delete
// </button>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))}

//                 {filtered.length === 0 && (
//                   <tr>
//                     <td colSpan="5" className="text-center py-12 text-gray-500">
//                       No staff found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* Right Sliding Panel */}
//       <div
//         className={`fixed inset-y-0 right-0 z-50 w-full max-w-lg bg-white shadow-2xl transform transition-transform duration-300 ease-in-out ${
//           isPanelOpen ? "translate-x-0" : "translate-x-full"
//         }`}
//       >
//         <div className="h-full flex flex-col">
//           <div className="flex justify-between items-center p-6 border-b border-gray-200">
//             <h2 className="text-2xl font-bold text-gray-900">
//               {selectedUser ? "Edit Staff" : "Add New Staff"}
//             </h2>
//             <button onClick={closePanel} className="p-2 hover:bg-gray-100 rounded-lg transition">
//               <XMarkIcon className="w-6 h-6 text-gray-600" />
//             </button>
//           </div>
//           <div className="flex-1 overflow-y-auto p-8">
//             <StaffForm
//               user={selectedUser}
//               onDone={() => {
//                 closePanel();
//                 load();
//               }}
//               onCancel={closePanel}
              
//             />
//           </div>
//         </div>
//       </div>

//       {/* Overlay */}
//       {isPanelOpen && (
//         <div onClick={closePanel} className="fixed inset-0 bg-black bg-opacity-40 z-40" />
//       )}
//     </div>
//   );
// }


// // src/pages/Staff/StaffList.jsx
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";
// import StaffForm from "./StaffForm";
// import { formatUserId } from "../../utils/formatId";
// import { EllipsisVerticalIcon, XMarkIcon } from "@heroicons/react/24/outline";
// import { useOutletContext } from 'react-router-dom';
// export default function StaffList() {
//    const { mode } = useOutletContext();
//   const isDark = mode === "dark";

//   const [users, setUsers] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [teams, setTeams] = useState([]);
//   const [query, setQuery] = useState("");
//   const [roleFilter, setRoleFilter] = useState("All");
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [isPanelOpen, setIsPanelOpen] = useState(false);
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [deleting, setDeleting] = useState(false);

//   const getRoleCaption = (roleId) => {
//     const role = roles.find((r) => r.id === roleId);
//     return role ? (role.caption || role.name) : "Unknown";
//   };

//   async function load() {
//     try {
//       const [userRes, roleRes, teamRes] = await Promise.all([
//         api.get("/users"),
//         api.get("/roles"),
//         api.get("/teams"),
//       ]);
//       setUsers(userRes.data.users || []);
//       setRoles(roleRes.data.roles || []);
//       setTeams(teamRes.data.teams || []);
//     } catch (err) {
//       console.error("Load failed:", err);
//       alert("Failed to load staff data");
//     }
//   }

//   useEffect(() => {
//     load();
//   }, []);

//   const filtered = users.filter((u) => {
//     const searchText = [u.name, u.email, getRoleCaption(u.role_id)].join(" ").toLowerCase();
//     const matchesQuery = !query || searchText.includes(query.toLowerCase());
//     const matchesRole = roleFilter === "All" || u.role_id === Number(roleFilter);
//     return matchesQuery && matchesRole;
//   });

//   async function remove(id) {
//     if (deleting) return;
//     if (!window.confirm("Are you sure you want to delete this user?")) return;

//     setDeleting(true);
//     try {
//       await api.delete(`/users/${id}`);
//       setUsers((prev) => prev.filter((u) => u.id !== id));
//       setOpenMenuId(null);
//       alert("User deleted successfully");
//     } catch (err) {
//       const message = err?.response?.data?.message || "Failed to delete user.";
//       alert(message);
//     } finally {
//       setDeleting(false);
//     }
//   }

//   const openAddPanel = () => {
//     setSelectedUser(null);
//     setIsPanelOpen(true);
//   };

//   const openEditPanel = (user) => {
//     setSelectedUser(user);
//     setIsPanelOpen(true);
//   };

//   const closePanel = () => {
//     setIsPanelOpen(false);
//     setSelectedUser(null);
//   };

//   return (
//     <div className={`min-h-screen py-8 px-6 ${isDark ? "bg-slate-900" : "bg-gray-50"}`}>
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-8">
//           <h1 className={`text-3xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>All Staff</h1>
//           <button
//             onClick={openAddPanel}
//             className={`px-8 py-3 font-bold rounded-xl shadow-lg transition ${
//               isDark ? "bg-slate-800 hover:bg-orange-600 text-white" : "bg-[#0f172a] hover:bg-orange-600 text-white"
//             }`}
//           >
//             + Add Staff
//           </button>
//         </div>

//         {/* Search & Filter */}
//         <div className="flex flex-col md:flex-row gap-4 mb-8">
//           <input
//             type="text"
//             placeholder="Search by name, email, role..."
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             className={`flex-1 px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
//               isDark
//                 ? "bg-slate-700 border-slate-600 text-white placeholder-slate-400"
//                 : "bg-white border-gray-300 text-gray-900 placeholder-gray-400"
//             }`}
//           />
//           <select
//             value={roleFilter}
//             onChange={(e) => setRoleFilter(e.target.value)}
//             className={`px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
//               isDark
//                 ? "bg-slate-700 border-slate-600 text-white"
//                 : "bg-white border-gray-300 text-gray-900"
//             }`}
//           >
//             <option value="All">All Roles</option>
//             {roles.map((r) => (
//               <option key={r.id} value={r.id}>
//                 {r.caption || r.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Table */}
//         <div
//           className={`rounded-2xl shadow-xl overflow-hidden border ${
//             isDark ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200"
//           }`}
//         >
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className={`${isDark ? "bg-slate-700" : "bg-gray-100"} border-b-2 ${isDark ? "border-slate-600" : "border-gray-300"}`}>
//                 <tr>
//                   <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>ID</th>
//                   <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Name</th>
//                   <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>User Role</th>
//                   <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Registration Date</th>
//                   <th className={`px-6 py-4 text-center text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody className={`divide-y ${isDark ? "divide-slate-700" : "divide-gray-200"}`}>
//                 {filtered.map((u) => (
//                   <tr key={u.id} className={`hover:${isDark ? "bg-slate-700/50" : "bg-orange-50/30"} transition-colors`}>
//                     <td className={`px-6 py-4 font-bold text-sm ${isDark ? "text-orange-400" : "text-orange-600"}`}>
//                       {formatUserId(u.id)}
//                     </td>
//                     <td className={`px-6 py-4 font-medium text-sm ${isDark ? "text-white" : "text-gray-900"}`}>{u.name}</td>
//                     <td className={`px-6 py-4 text-sm ${isDark ? "text-slate-300" : "text-gray-700"}`}>
//                       {getRoleCaption(u.role_id)}
//                     </td>
//                     <td className={`px-6 py-4 text-sm ${isDark ? "text-slate-400" : "text-gray-600"}`}>
//                       {new Date(u.created_at).toLocaleDateString("en-GB")} |{" "}
//                       {new Date(u.created_at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
//                     </td>
//                     <td className="px-6 py-4 text-center relative">
//                       <button
//                         onClick={() => setOpenMenuId(openMenuId === u.id ? null : u.id)}
//                         disabled={deleting}
//                         className={`p-2 rounded-lg transition disabled:opacity-50 ${
//                           isDark ? "hover:bg-slate-700" : "hover:bg-gray-100"
//                         }`}
//                       >
//                         <EllipsisVerticalIcon className={`w-5 h-5 ${isDark ? "text-slate-400" : "text-gray-500"}`} />
//                       </button>

//                       {openMenuId === u.id && (
//                         <div
//                           className={`absolute right-6 top-12 rounded-xl shadow-2xl py-2 z-50 min-w-36 ${
//                             isDark ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200"
//                           } border`}
//                         >
//                           <button
//                             onClick={() => {
//                               openEditPanel(u);
//                               setOpenMenuId(null);
//                             }}
//                             className={`w-full text-left px-5 py-2.5 text-sm transition ${
//                               isDark ? "text-slate-200 hover:bg-slate-700" : "text-gray-700 hover:bg-orange-50"
//                             }`}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             onClick={() => remove(u.id)}
//                             disabled={deleting}
//                             className={`w-full text-left px-5 py-2.5 text-sm transition ${
//                               isDark ? "text-red-400 hover:bg-red-950/30" : "text-red-600 hover:bg-red-50"
//                             } disabled:opacity-50`}
//                           >
//                             {deleting ? "Deleting..." : "Delete"}
//                           </button>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))}

//                 {filtered.length === 0 && (
//                   <tr>
//                     <td colSpan="5" className={`text-center py-12 ${isDark ? "text-slate-400" : "text-gray-500"}`}>
//                       No staff found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* Right Sliding Panel */}
//       <div
//         className={`fixed inset-y-0 right-0 z-50 w-full max-w-lg shadow-2xl transform transition-transform duration-300 ease-in-out ${
//           isPanelOpen ? "translate-x-0" : "translate-x-full"
//         } ${isDark ? "bg-slate-900" : "bg-white"}`}
//       >
//         <div className="h-full flex flex-col">
//           <div
//             className={`flex justify-between items-center p-6 border-b ${
//               isDark ? "border-slate-700" : "border-gray-200"
//             }`}
//           >
//             <h2 className={`text-2xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
//               {selectedUser ? "Edit Staff" : "Add New Staff"}
//             </h2>
//             <button
//               onClick={closePanel}
//               className={`p-2 rounded-lg transition ${
//                 isDark ? "hover:bg-slate-700" : "hover:bg-gray-100"
//               }`}
//             >
//               <XMarkIcon className={`w-6 h-6 ${isDark ? "text-slate-400" : "text-gray-600"}`} />
//             </button>
//           </div>
//           <div className="flex-1 overflow-y-auto p-8">
//             <StaffForm
//               user={selectedUser}
//               onDone={() => {
//                 closePanel();
//                 load();
//               }}
//               onCancel={closePanel}
//               mode={mode} // ← pass dark/light mode
//             />
//           </div>
//         </div>
//       </div>

//       {/* Overlay */}
//       {isPanelOpen && (
//         <div onClick={closePanel} className="fixed inset-0 bg-black bg-opacity-40 z-40" />
//       )}
//     </div>
//   );
// }

// src/pages/Staff/StaffList.jsx
import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/api";
import StaffForm from "./StaffForm";
import { formatUserId } from "../../utils/formatId";
import { EllipsisVerticalIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useOutletContext } from 'react-router-dom';

// Reusable Action Menu for each row
function ActionMenu({ user, onEdit, onDelete, isDark, deleting }) {
  const menuRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={menuRef} className="inline-block relative">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        disabled={deleting}
        className={`p-2 rounded-lg transition disabled:opacity-50 ${
          isDark ? "hover:bg-slate-700" : "hover:bg-gray-100"
        }`}
      >
        <EllipsisVerticalIcon className={`w-5 h-5 ${isDark ? "text-slate-400" : "text-gray-500"}`} />
      </button>

      {isOpen && (
        <div
          className={`absolute right-0 top-10 rounded-xl shadow-2xl py-2 z-50 min-w-36 border ${
            isDark ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200"
          }`}
        >
          <button
            onClick={() => {
              onEdit(user);
              setIsOpen(false);
            }}
            className={`w-full text-left px-5 py-2.5 text-sm transition ${
              isDark ? "text-slate-200 hover:bg-slate-700" : "text-gray-700 hover:bg-orange-50"
            }`}
          >
            Edit
          </button>

          <button
            onClick={() => {
              onDelete(user.id);
              setIsOpen(false);
            }}
            disabled={deleting}
            className={`w-full text-left px-5 py-2.5 text-sm transition ${
              isDark ? "text-red-400 hover:bg-red-950/30" : "text-red-600 hover:bg-red-50"
            } disabled:opacity-50`}
          >
            {deleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      )}
    </div>
  );
}

export default function StaffList() {
  const { mode } = useOutletContext();
  const isDark = mode === "dark";

  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [teams, setTeams] = useState([]);
  const [query, setQuery] = useState("");
  const [roleFilter, setRoleFilter] = useState("All");
  const [selectedUser, setSelectedUser] = useState(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const getRoleCaption = (roleId) => {
    const role = roles.find((r) => r.id === roleId);
    return role ? (role.caption || role.name) : "Unknown";
  };

  async function load() {
    try {
      const [userRes, roleRes, teamRes] = await Promise.all([
        api.get("/users"),
        api.get("/roles"),
        api.get("/teams"),
      ]);
      setUsers(userRes.data.users || []);
      setRoles(roleRes.data.roles || []);
      setTeams(teamRes.data.teams || []);
    } catch (err) {
      console.error("Load failed:", err);
      alert("Failed to load staff data");
    }
  }

  useEffect(() => {
    load();
  }, []);

  const filtered = users.filter((u) => {
    const searchText = [u.name, u.email, getRoleCaption(u.role_id)].join(" ").toLowerCase();
    const matchesQuery = !query || searchText.includes(query.toLowerCase());
    const matchesRole = roleFilter === "All" || u.role_id === Number(roleFilter);
    return matchesQuery && matchesRole;
  });

  async function remove(id) {
    if (deleting) return;
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    setDeleting(true);
    try {
      await api.delete(`/users/${id}`);
      setUsers((prev) => prev.filter((u) => u.id !== id));
      alert("User deleted successfully");
    } catch (err) {
      const message = err?.response?.data?.message || "Failed to delete user.";
      alert(message);
    } finally {
      setDeleting(false);
    }
  }

  const openAddPanel = () => {
    setSelectedUser(null);
    setIsPanelOpen(true);
  };

  const openEditPanel = (user) => {
    setSelectedUser(user);
    setIsPanelOpen(true);
  };

  const closePanel = () => {
    setIsPanelOpen(false);
    setSelectedUser(null);
  };

  return (
    <div className={`min-h-screen py-8 px-6 ${isDark ? "bg-slate-900" : "bg-gray-50"}`}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <h1 className={`text-3xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>All Staff</h1>
          <button
            onClick={openAddPanel}
            className={`px-8 py-3 font-bold rounded-xl shadow-lg transition ${
              isDark ? "bg-slate-800 hover:bg-orange-600 text-white" : "bg-[#0f172a] hover:bg-orange-600 text-white"
            }`}
          >
            + Add Staff
          </button>
        </div>

        {/* Search & Filter */}
        <div className="flex flex-col md:flex-row gap-4 mb-8">
          <input
            type="text"
            placeholder="Search by name, email, role..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className={`flex-1 px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
              isDark
                ? "bg-slate-700 border-slate-600 text-white placeholder-slate-400"
                : "bg-white border-gray-300 text-gray-900 placeholder-gray-400"
            }`}
          />
          <select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
            className={`px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
              isDark
                ? "bg-slate-700 border-slate-600 text-white"
                : "bg-white border-gray-300 text-gray-900"
            }`}
          >
            <option value="All">All Roles</option>
            {roles.map((r) => (
              <option key={r.id} value={r.id}>
                {r.caption || r.name}
              </option>
            ))}
          </select>
        </div>

        {/* Table */}
        <div
          className={`rounded-2xl shadow-xl overflow-hidden border ${
            isDark ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200"
          }`}
        >
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className={`${isDark ? "bg-slate-700" : "bg-gray-100"} border-b-2 ${isDark ? "border-slate-600" : "border-gray-300"}`}>
                <tr>
                  <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>User Code</th>
                  <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Name</th>
                  <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>User Role</th>
                  <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Registration Date</th>
                  <th className={`px-6 py-4 text-center text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Actions</th>
                </tr>
              </thead>
              <tbody className={`divide-y ${isDark ? "divide-slate-700" : "divide-gray-200"}`}>
                {filtered.map((u) => (
                  <tr key={u.id} className={`hover:${isDark ? "bg-slate-700/50" : "bg-orange-50/30"} transition-colors`}>
                    <td className={`px-6 py-4 font-bold text-sm ${isDark ? "text-orange-400" : "text-orange-600"}`}>
                      {formatUserId(u.id)}
                    </td>
                    <td className={`px-6 py-4 font-medium text-sm ${isDark ? "text-white" : "text-gray-900"}`}>
                      {u.name}
                    </td>
                    <td className={`px-6 py-4 text-sm ${isDark ? "text-slate-300" : "text-gray-700"}`}>
                      {getRoleCaption(u.role_id)}
                    </td>
                    <td className={`px-6 py-4 text-sm ${isDark ? "text-slate-400" : "text-gray-600"}`}>
                      {new Date(u.created_at).toLocaleDateString("en-GB")} |{" "}
                      {new Date(u.created_at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <ActionMenu
                        user={u}
                        onEdit={openEditPanel}
                        onDelete={remove}
                        isDark={isDark}
                        deleting={deleting}
                      />
                    </td>
                  </tr>
                ))}

                {filtered.length === 0 && (
                  <tr>
                    <td colSpan="5" className={`text-center py-12 ${isDark ? "text-slate-400" : "text-gray-500"}`}>
                      No staff found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Right Sliding Panel */}
      <div
        className={`fixed inset-y-0 right-0 z-50 w-full max-w-lg shadow-2xl transform transition-transform duration-300 ease-in-out ${
          isPanelOpen ? "translate-x-0" : "translate-x-full"
        } ${isDark ? "bg-slate-900" : "bg-white"}`}
      >
        <div className="h-full flex flex-col">
          <div
            className={`flex justify-between items-center p-6 border-b ${
              isDark ? "border-slate-700" : "border-gray-200"
            }`}
          >
            <h2 className={`text-2xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
              {selectedUser ? "Edit Staff" : "Add New Staff"}
            </h2>
            <button
              onClick={closePanel}
              className={`p-2 rounded-lg transition ${
                isDark ? "hover:bg-slate-700" : "hover:bg-gray-100"
              }`}
            >
              <XMarkIcon className={`w-6 h-6 ${isDark ? "text-slate-400" : "text-gray-600"}`} />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-8">
            <StaffForm
              user={selectedUser}
              onDone={() => {
                closePanel();
                load();
              }}
              onCancel={closePanel}
              mode={mode}
            />
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isPanelOpen && (
        <div onClick={closePanel} className="fixed inset-0 bg-black bg-opacity-40 z-40" />
      )}
    </div>
  );
}